/** One CSV cell: quoted when it holds a comma, quote or newline. */
export function csvCell(v: string | number | bigint | boolean | null | undefined): string {
  const s = v === null || v === undefined ? '' : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Rows → CSV text (header first). */
export function toCsv(
  header: string[],
  rows: Array<Array<string | number | bigint | boolean | null | undefined>>,
): string {
  return [header, ...rows].map((r) => r.map(csvCell).join(',')).join('\n');
}

/**
 * Save text as a file. A UTF-8 BOM is prepended so Excel on Windows reads
 * non-ASCII names (Tamil display names) correctly.
 */
export function downloadText(filename: string, text: string, type = 'text/csv;charset=utf-8'): void {
  const url = URL.createObjectURL(new Blob(['﻿', text], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Walk a cursor-paged list endpoint to the end (or `maxRows`) and return every
 * row. `fetchPage` gets the cursor of the previous page (undefined first).
 */
export async function fetchAllPages<T>(
  fetchPage: (cursor: string | undefined) => Promise<{ items: T[]; nextCursor: string | null }>,
  maxRows = 5000,
): Promise<{ rows: T[]; truncated: boolean }> {
  const rows: T[] = [];
  let cursor: string | undefined;
  for (;;) {
    const page = await fetchPage(cursor);
    rows.push(...page.items);
    if (!page.nextCursor) return { rows, truncated: false };
    if (rows.length >= maxRows) return { rows: rows.slice(0, maxRows), truncated: true };
    cursor = page.nextCursor;
  }
}
